import { LeaderboardItem } from "../api/types";
import { Team } from "../types/team";

export const deserializeLeaderboard = (
  item: LeaderboardItem,
  index: number,
): Team => ({
  rank: index + 1,
  id: item.legacyId,
  name: item.title,
  raised: Number(item.donationAmount ?? 0) / 100,
  slug: item.slug,
  currency: item.currencyCode ?? "",
  currencySymbol: item.currencySymbol ?? "£",
});
